import React from 'react';

const About = () => {
    return (
        <div>

         <section class="story">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <img loading="lazy" src="https://i0.wp.com/parkview.com.bd/wp-content/uploads/2018/09/DrATMRezaulKarim.jpg?w=600&ssl=1" class="responsive" alt="story"/>
      </div>
      <div class="col-lg-6">
        <div class="story-content">
          <h2>Our Story</h2>
          <h5 class="tagline"> It is indeed a great pleasure for me to introduce our brand new state – of – the -art technology hospital in the region of Chittagong. Nowadays, if anyone needs good treatment, they need to look forward to Dhaka or Abroad. Because good and well facilitated hospitals are not available in the port city of Chittagong.

So, we needed to decentralize and step forward to establish well facilitate and modern hospital in Chittagong city. Moreover, we felt that our integrated Township of Chittagong city, the second capital and largest sea-port of Bangladesh, would be incomplete without a good health care facility like Parkview Hospital that is going to be a well-equipped modern multi specialty hospital. In view of that, Parkview Hospital was incorporated in Chittagong, Bangladesh in the year 2013 under the company act 1994.

We as a team are quite optimistic that it will render the required level of expertise and services to the community. Parkview is a multidisciplinary hospital with all major medical specialties and with special focuses on center of excellences in Orthopedic Surgery and Traumatology, Urology and Nephrology, Obstetrics and Gynecology, Gastroenterology, Family medicine, ENT, and so on with Minimally Invasive Surgeries.

Parkview is committed to provide the highest quality health care services to local community while being financially affordable. Achieving a high level of quality is the result of many factors </h5>

State-of-the-Art Technology
Caring people
Medical expertise
Clinical excellence
Health care management

The pursuit of excellence in all these areas is the result of our willingness, commitment, dedication and strong moral determination to provide the highest quality of care. It is my desire and hope of everyone at Parkview to bring a level of excellence to the Total Healthcare Delivery System of the country which will be a model for others to follow.
            <h6>Mission</h6>
            <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nam nihil dolorum beatae consequatur mollitia
              iure?</p>
            <h6>Vision</h6>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda consectetur adipisci, voluptatum
              dolores nostrum omnis.</p>
        </div>
      </div>
    </div>
  </div>
</section>


<section class="promo-video">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="block text-center">
          <h6>About Our Hospital</h6>
          <h1>The World <br/>
            Class Hospitality
          </h1>
          <a data-fancybox
            href="https://www.youtube.com/watch?v=_sI_Ps7JSEk&amp;autoplay=1&amp;rel=0&amp;controls=0&amp;showinfo=0"><i class="fas fa-play"></i></a>
        </div>
      </div>
    </div>
  </div>
</section>
</div>

    );
};

export default About;